import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { doc, onSnapshot, updateDoc, collection, collectionGroup, query, where, setDoc, getDoc, getDocs, deleteDoc, serverTimestamp, increment } from 'firebase/firestore';
import TorneiosPK from './TorneiosPK';
import { enviarNotificacao } from "./notificacoesService";

function ChampionsPK({ torneioId }) {
  const [meusDados, setMeusDados] = useState(null);
  const [utilizadoresOnline, setUtilizadoresOnline] = useState([]);
  const [batalhaAtiva, setBatalhaAtiva] = useState(null);
  const [modoEspectador, setModoEspectador] = useState(false);
  const [inscritos, setInscritos] = useState([]);
  const [nomeClube, setNomeClube] = useState('');
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [dadosTorneio, setDadosTorneio] = useState(null);
  const [resgatandoPremio, setResgatandoPremio] = useState(false); // 🚨 NOVO CONTROLADOR DE PREMIAÇÃO
  
  const [salaSelecionadaId, setSalaSelecionadaId] = useState(torneioId || "estadio_global_ativo");

  // ANTENA DA ESTEIRA INTELIGENTE COM RETENÇÃO ATÓMICA E MEMÓRIA DE CAMPEÃO
  useEffect(() => {
    let unsubGlobal = () => {};
    let unsubSalaAtiva = () => {};

    // 1. Faz uma varredura nas árvores ativas em andamento no servidor
    const qChaves = query(collection(db, "champions_ativa"));

    const unsubVerifica = onSnapshot(qChaves, async (snap) => {
      let salaTorneioId = null;
      let arvoreGuardada = null;
      const meuUid = auth.currentUser?.uid;

      if (!meuUid) return;

      // Varre as chaves procurando se o utilizador faz parte de QUALQUER fase ativa da árvore
      for (const documento of snap.docs) {
        const dados = documento.data();

        const nosQuartos = 
          dados.jogo1?.p1?.uid === meuUid || dados.jogo1?.p2?.uid === meuUid ||
          dados.jogo2?.p1?.uid === meuUid || dados.jogo2?.p2?.uid === meuUid ||
          dados.jogo3?.p1?.uid === meuUid || dados.jogo3?.p2?.uid === meuUid ||
          dados.jogo4?.p1?.uid === meuUid || dados.jogo4?.p2?.uid === meuUid;

        const nasMeias = 
          dados.meia1?.p1?.uid === meuUid || dados.meia1?.p2?.uid === meuUid ||
          dados.meia2?.p1?.uid === meuUid || dados.meia2?.p2?.uid === meuUid;

        const naFinal = 
          dados.final?.p1?.uid === meuUid || dados.final?.p2?.uid === meuUid;
        
        if (nosQuartos || nasMeias || naFinal) {
          // DETETOR DE ELIMINAÇÃO: Se o jogador perdeu o seu confronto direto e o jogo já fechou, liberta-o!
          let estouEliminado = false;
          
          if (nosQuartos) {
            if (dados.jogo1?.p1?.uid === meuUid && dados.jogo1?.status === "encerrado" && dados.jogo1?.vencedor !== meuUid) estouEliminado = true;
            if (dados.jogo1?.p2?.uid === meuUid && dados.jogo1?.status === "encerrado" && dados.jogo1?.vencedor !== meuUid) estouEliminado = true;
            if (dados.jogo2?.p1?.uid === meuUid && dados.jogo2?.status === "encerrado" && dados.jogo2?.vencedor !== meuUid) estouEliminado = true;
            if (dados.jogo2?.p2?.uid === meuUid && dados.jogo2?.status === "encerrado" && dados.jogo2?.vencedor !== meuUid) estouEliminado = true;
            if (dados.jogo3?.p1?.uid === meuUid && dados.jogo3?.status === "encerrado" && dados.jogo3?.vencedor !== meuUid) estouEliminado = true;
            if (dados.jogo3?.p2?.uid === meuUid && dados.jogo3?.status === "encerrado" && dados.jogo3?.vencedor !== meuUid) estouEliminado = true;
            if (dados.jogo4?.p1?.uid === meuUid && dados.jogo4?.status === "encerrado" && dados.jogo4?.vencedor !== meuUid) estouEliminado = true;
            if (dados.jogo4?.p2?.uid === meuUid && dados.jogo4?.status === "encerrado" && dados.jogo4?.vencedor !== meuUid) estouEliminado = true;
          }
          if (nasMeias) {
            if (dados.meia1?.p1?.uid === meuUid && dados.meia1?.status === "encerrado" && dados.meia1?.vencedor !== meuUid) estouEliminado = true;
            if (dados.meia1?.p2?.uid === meuUid && dados.meia1?.status === "encerrado" && dados.meia1?.vencedor !== meuUid) estouEliminado = true;
            if (dados.meia2?.p1?.uid === meuUid && dados.meia2?.status === "encerrado" && dados.meia2?.vencedor !== meuUid) estouEliminado = true;
            if (dados.meia2?.p2?.uid === meuUid && dados.meia2?.status === "encerrado" && dados.meia2?.vencedor !== meuUid) estouEliminado = true;
          }

          // Se o torneio terminou de vez e ele foi o perdedor da final, liberta-o de imediato
          if (dados.faseGeral === "FIM" && dados.final?.vencedor !== meuUid) {
            estouEliminado = true;
          }

          // 🚨 ATENÇÃO MESTRE: Se ele for o CAMPEÃO, ele FICA PRESO na árvore até clicar em resgatar o pote!
          if (!estouEliminado) {
            salaTorneioId = documento.id;
            arvoreGuardada = dados;
            break;
          }
        }
      }

      // SE O UTILIZADOR CONTINUA ATIVO NA ÁRVORE (OU É O CAMPEÃO POR PREMIAR), TRANCADO NESTE CAMPEONATO!
      if (salaTorneioId && arvoreGuardada) {
        setSalaSelecionadaId(salaTorneioId);
        setDadosTorneio(arvoreGuardada);
        
        unsubSalaAtiva = onSnapshot(doc(db, "champions_ativa", salaTorneioId), (docSnap) => {
          if (docSnap.exists()) setDadosTorneio(docSnap.data());
        });
      } else {
        // SE FOI ELIMINADO OU JÁ RECEBEU O PRÉMIO, FICA LIVRE PARA NOVAS VAGAS!
        setInscritos([]);
        setDadosTorneio(null);
        
        const docRef = doc(db, "controlo_champions", "torneio_atual");
        unsubGlobal = onSnapshot(docRef, (snapGlobal) => {
          if (snapGlobal.exists()) {
            setSalaSelecionadaId(snapGlobal.data().idSalaAtiva || "estadio_global_ativo");
          } else {
            setSalaSelecionadaId("estadio_global_ativo");
          }
        });
      }
    });

    return () => {
      unsubVerifica();
      unsubGlobal();
      unsubSalaAtiva();
    };
  }, []);

  const [listaTorneiosPublicos, setListaTorneiosPublicos] = useState([]);

    // SENSOR GLOBAL DE LOBBY: Puxa todos os estádios abertos no mundo com vagas livres
  useEffect(() => {
    const q = query(collection(db, "torneios_abertos"), where("status", "==", "aguardando"));
    const unsub = onSnapshot(q, (snap) => {
      setListaTorneiosPublicos(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // GERADOR DE ESTÁDIOS: Cria uma sala única e pública no banco de dados
  const criarNovoEstadioPublico = async () => {
    const novoIdSala = `torneio_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
    const { doc: fDoc, setDoc: fSetDoc, serverTimestamp: fServerTimestamp } = await import('firebase/firestore');
    
    await fSetDoc(fDoc(db, "torneios_abertos", novoIdSala), {
      status: "aguardando",
      totalVagasPreenchidas: 0,
      criadoEm: fServerTimestamp(),
      criadorNome: auth.currentUser?.displayName || "Craque"
    });
    setSalaSelecionadaId(novoIdSala);
  };

  const [jogoAtualNoFirebase, setJogoAtualNoFirebase] = useState('');
  const [meusBloqueados, setMeusBloqueados] = useState([]);
  const [quemMeBloqueou, setQuemMeBloqueou] = useState([]);

  // ANTENA DE PARTICIPANTES DA SALA: Monitoriza os inscritos deste estádio dinâmico
  useEffect(() => {
    const idDaMinhaSala = torneioId || salaSelecionadaId;
    if (!idDaMinhaSala) return;

    const q = query(collection(db, "champions_salas", idDaMinhaSala, "inscritos"));
    const unsub = onSnapshot(q, (snap) => {
      const lista = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setInscritos(lista.filter(i => !meusBloqueados.includes(i.uid) && !quemMeBloqueou.includes(i.uid)));
    });
    return () => unsub();
  }, [torneioId, salaSelecionadaId, meusBloqueados, quemMeBloqueou]);

  useEffect(() => {
    if (!auth.currentUser) return;
    const uMeus = onSnapshot(collection(db, "utilizadores", auth.currentUser.uid, "bloqueados"), (s) => {
      setMeusBloqueados(s.docs.map(d => d.id));
    });
    const unsubDeles = onSnapshot(collectionGroup(db, "bloqueados"), (snap) => {
      const ids = [];
      snap.forEach(doc => {
        if (doc.id === auth.currentUser?.uid) {
          ids.push(doc.ref.parent.parent.id);
        }
      });
      setQuemMeBloqueou(ids);
    });

    return () => { uMeus(); unsubDeles(); };
  }, []);

    useEffect(() => {
    // Quem chega com ?batalha=<id> no URL veio de uma notificação só para ASSISTIR.
    const entrouComoEspectador = !!new URLSearchParams(window.location.search).get('batalha');
    const idDaMinhaSala = torneioId || salaSelecionadaId;

    if (!entrouComoEspectador && auth.currentUser) {
      // ISOLAMENTO CHAMPIONS: Altera para emChampions para não vazar na lista padrão do ArenaPK!
      import('firebase/firestore').then(({ doc: fDoc, updateDoc: fUpdateDoc }) => {
        fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), { emChampions: true }).catch(() => {});
      });

      // AVISAR SEGUIDORES QUE ENTREI NA CHAMPIONS COM A SALA DINÂMICA CERTA
      const avisarChampionsEntrada = async () => {
        const seguidoresRef = collection(db, "utilizadores", auth.currentUser.uid, "seguidores");
        const snap = await getDocs(seguidoresRef);
        snap.forEach((docSeguidor) => {
          enviarNotificacao(
            docSeguidor.id,
            auth.currentUser.uid,
            auth.currentUser.displayName || "Um craque",
            "champions_pk",
            { batalhaId: auth.currentUser.uid, torneioId: idDaMinhaSala }
          );
        });
      };
      avisarChampionsEntrada();
    }

    const unsub = onSnapshot(doc(db, "utilizadores", auth.currentUser.uid), (docSnap) => {
      if (docSnap.exists()) {
        const dados = docSnap.data();
        setMeusDados(dados);
        // Se o meu status mudar para aceite, eu entro na batalha como jogador
        if (dados.convitePK?.status === 'aceite' && !modoEspectador) {
           setBatalhaAtiva(dados.convitePK.idBatalha);
        }
      }
    });

    return () => {
      if (!entrouComoEspectador && auth.currentUser) {
        // Limpa o estado de Champions de forma isolada ao fechar o ecrã
        import('firebase/firestore').then(({ doc: fDoc, updateDoc: fUpdateDoc }) => {
          fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), { emChampions: false }).catch(() => {});
        });
      }
      unsub();
    };
  }, [modoEspectador, torneioId, salaSelecionadaId]);

  // SENSOR DE SALA INFINITA COM ALERTA DE PRIORIDADE E RADAR ESPIÃO (CORRIGIDO PARA MEIAS E FINAL!)
  useEffect(() => {
    const idDaMinhaSala = torneioId || salaSelecionadaId;
    if (!idDaMinhaSala) return;

    const unsub = onSnapshot(doc(db, "champions_ativa", idDaMinhaSala), (docSnap) => {
      if (docSnap.exists()) {
        const arvore = docSnap.data();
        setDadosTorneio(arvore);

        // RADAR DE ENTRADA AUTOMÁTICA: Puxa o rival para as câmaras no segundo exato em que o jogo arranca!
        const meuUid = auth.currentUser?.uid;
        if (meuUid) {
          // Mapeamento direto de chaves para evitar falhas de idBatalha nas Meias ou Final
          const chavesFases = ["jogo1", "jogo2", "jogo3", "jogo4", "meia1", "meia2", "final"];
          let nomeNoFirebase = "";
          let meuJogoAtivo = null;

          for (const chave of chavesFases) {
            const j = arvore?.[chave];
            if (j?.status === "em_andamento" && (j?.p1?.uid === meuUid || j?.p2?.uid === meuUid)) {
              nomeNoFirebase = chave;
              meuJogoAtivo = j;
              break;
            }
          }

          if (nomeNoFirebase && meuJogoAtivo) {
            setJogoAtualNoFirebase(nomeNoFirebase);
            setModoEspectador(false);
            setBatalhaAtiva(meuJogoAtivo.idBatalha);
          }
        }
      } else {
        setDadosTorneio(null);
        setMostrarPopup(false);
      }
    });
    return () => unsub();
  }, [torneioId, salaSelecionadaId]);

  useEffect(() => {
    // Monitoriza os utilizadores online incluindo quem está na Champions ou em Live Comum
    const q = query(collection(db, "utilizadores"));
    const unsub = onSnapshot(q, (snap) => {
      setUtilizadoresOnline(snap.docs
        .map(d => ({ uid: d.id, ...d.data() }))
        .filter(u => (u.emLive === true || u.emChampions === true) && u.uid !== auth.currentUser.uid && !meusBloqueados.includes(u.uid) && !quemMeBloqueou.includes(u.uid))
      );
    });
    return () => unsub();
  }, [meusBloqueados, quemMeBloqueou]);

  // NOVOS ESTADOS DECLARADOS PARA EXIBIR AS DUAS METRICAS DO POTE NA ÁRVORE MESTRE
  const [poteBolasGeral, setPoteBolasGeral] = useState(0);

  useEffect(() => {
    const idDaMinhaSala = torneioId || salaSelecionadaId;
    if (!idDaMinhaSala) return;

    // POTE EM TEMPO REAL ISOLADO: Escuta os campos premium oficiais calibrados na contabilidade!
    const unsub = onSnapshot(doc(db, "champions_ativa", idDaMinhaSala), (docSnap) => {
      if (docSnap.exists()) {
        const dados = docSnap.data();
        setPoteBolasGeral(dados.poteBolasGlobalArvore || dados.poteBolasGlobal || 0);
      }
    });
    return () => unsub();
  }, [torneioId, salaSelecionadaId]);

    useEffect(() => {
    // ENTRADA POR NOTIFICAÇÃO: /?champions&batalha=<id> abre a batalha como espectador.
    const idBat = new URLSearchParams(window.location.search).get('batalha');
    if (idBat) {
      setModoEspectador(true);
      setBatalhaAtiva(idBat);
    }
  }, []);

  useEffect(() => {
    // Se a Márcia ou a Teresa vierem da notificação da Champions
    if (torneioId && torneioId !== auth.currentUser?.uid) {
      setModoEspectador(true);
      setBatalhaAtiva(torneioId);
    }
  }, [torneioId]);

    // 🛡️ MOTOR DE EMPARELHAMENTO ATÓMICO DA CHAMPIONS (RESTRUTURADO SEM APAGAMENTO CEGO)
  useEffect(() => {
    if (!dadosTorneio) return;

    const atualizarTorneioMestre = async () => {
      let mudou = false;
      const novaArvore = { ...dadosTorneio };
      const idDaMinhaSala = torneioId || salaSelecionadaId;
      if (!idDaMinhaSala) return;

      // 1. GERAR MEIA 1 AUTOMÁTICA (Vencedor Jogo 1 vs Vencedor Jogo 2)
      if (novaArvore.jogo1?.status === "encerrado" && novaArvore.jogo2?.status === "encerrado" && novaArvore.jogo1?.vencedor && novaArvore.jogo2?.vencedor && (!novaArvore.meia1 || !novaArvore.meia1.p1)) {
        const p1Data = novaArvore.jogo1.vencedor === novaArvore.jogo1.p1.uid ? novaArvore.jogo1.p1 : novaArvore.jogo1.p2;
        const p2Data = novaArvore.jogo2.vencedor === novaArvore.jogo2.p1.uid ? novaArvore.jogo2.p1 : novaArvore.jogo2.p2;
        
        if (p1Data && p2Data) {
          novaArvore.meia1 = { 
            p1: p1Data, 
            p2: p2Data, 
            vencedor: null, 
            status: 'pendente', 
            idBatalha: `champions_meia1_${Date.now()}_${idDaMinhaSala}` 
          };
          mudou = true;
        }
      }

      // 2. GERAR MEIA 2 AUTOMÁTICA (Vencedor Jogo 3 vs Vencedor Jogo 4)
      if (novaArvore.jogo3?.status === "encerrado" && novaArvore.jogo4?.status === "encerrado" && novaArvore.jogo3?.vencedor && novaArvore.jogo4?.vencedor && (!novaArvore.meia2 || !novaArvore.meia2.p1)) {
        const p1Data = novaArvore.jogo3.vencedor === novaArvore.jogo3.p1.uid ? novaArvore.jogo3.p1 : novaArvore.jogo3.p2;
        const p2Data = novaArvore.jogo4.vencedor === novaArvore.jogo4.p1.uid ? novaArvore.jogo4.p1 : novaArvore.jogo4.p2;
        
        if (p1Data && p2Data) {
          novaArvore.meia2 = { 
            p1: p1Data, 
            p2: p2Data, 
            vencedor: null, 
            status: 'pendente', 
            idBatalha: `champions_meia2_${Date.now()}_${idDaMinhaSala}` 
          };
          mudou = true;
        }
      }

      // 3. GERAR FINAL AUTOMÁTICA (Vencedor Meia 1 vs Vencedor Meia 2)
      if (novaArvore.meia1?.status === "encerrado" && novaArvore.meia2?.status === "encerrado" && novaArvore.meia1?.vencedor && novaArvore.meia2?.vencedor && (!novaArvore.final || !novaArvore.final.p1)) {
        const p1Data = novaArvore.meia1.vencedor === novaArvore.meia1.p1.uid ? novaArvore.meia1.p1 : novaArvore.meia1.p2;
        const p2Data = novaArvore.meia2.vencedor === novaArvore.meia2.p1.uid ? novaArvore.meia2.p1 : novaArvore.meia2.p2;
        
        if (p1Data && p2Data) {
          novaArvore.final = { 
            p1: p1Data, 
            p2: p2Data, 
            vencedor: null, 
            status: 'pendente', 
            idBatalha: `champions_final_${Date.now()}_${idDaMinhaSala}` 
          };
          novaArvore.faseGeral = 'FINAL';
          mudou = true;
        }
      }

      // 4. FIXAÇÃO DO ESTADO DE FIM DO TORNEIO (Tranca o ecrã para celebração e desativa a vassoura automática!)
      if (novaArvore.final?.status === 'encerrado' && novaArvore.final?.vencedor) {
        if (novaArvore.status !== "encerrado" || novaArvore.faseGeral !== "FIM") {
          novaArvore.status = "encerrado";
          novaArvore.faseGeral = "FIM";
          mudou = true;
        }
      }

      if (mudou) {
        const { doc: fDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
        await fUpdateDoc(fDoc(db, "champions_ativa", idDaMinhaSala), novaArvore).catch((e) => console.log("Erro ao atualizar avanços da árvore:", e));
      }
    };

    atualizarTorneioMestre();
  }, [salaSelecionadaId, torneioId, dadosTorneio?.jogo1?.vencedor, dadosTorneio?.jogo2?.vencedor, dadosTorneio?.jogo3?.vencedor, dadosTorneio?.jogo4?.vencedor, dadosTorneio?.meia1?.vencedor, dadosTorneio?.meia2?.vencedor, dadosTorneio?.final?.vencedor, dadosTorneio?.final?.status]);

  // 🚨 BANCO DIGITAL DA CHAMPIONS: Transfere o pote acumulado ao vivo para o Campeão e limpa a sala!
  const resgatarPremioFinalCampeao = async () => {
    if (resgatandoPremio || !dadosTorneio || dadosTorneio.faseGeral !== "FIM") return;
    const vencedorUid = dadosTorneio.final?.vencedor;
    if (vencedorUid !== auth.currentUser?.uid) return; // Só o Campeão Real pode disparar o saque!

    setResgatandoPremio(true);
    const idDaMinhaSala = torneioId || salaSelecionadaId;

    try {
      const { doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc, deleteDoc: fDeleteDoc, collection: fCollection, getDocs: fGetDocs, increment: fIncrement } = await import('firebase/firestore');
      
      // 1. Puxa os valores finais do prémio fixados no documento da árvore mestre
      const salaRef = fDoc(db, "champions_ativa", idDaMinhaSala);
      const snapSala = await fGetDoc(salaRef);
      if (!snapSala.exists()) return;

      const dadosFinaisSala = snapSala.data();
      const prémioBolasTotal = Math.round(dadosFinaisSala.poteBolasGlobalArvore || dadosFinaisSala.poteBolasGlobal || 0);

      if (prémioBolasTotal > 0) {
        // 2. Injeta o valor do pote de forma síncrona na conta do campeão no Firebase
        const userRef = fDoc(db, "utilizadores", vencedorUid);
        const snapUser = await fGetDoc(userRef);
        const campoSaldoVencedor = snapUser.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
        
        await fUpdateDoc(userRef, {
          [campoSaldoVencedor]: fIncrement(prémioBolasTotal),
          emChampions: false,
          conviteChampions: null
        });
      }

      // 3. Liberta as tabelas públicas de torneios abertos
      await fDeleteDoc(fDoc(db, "torneios_abertos", idDaMinhaSala)).catch(() => {});

      // 4. Limpa a subcoleção de inscritos do estádio anterior
      const inscritosSnap = await fGetDocs(fCollection(db, "champions_salas", idDaMinhaSala, "inscritos")).catch(() => {});
      if (inscritosSnap) {
        const delecoes = inscritosSnap.docs.map(d => fDeleteDoc(d.ref));
        await Promise.all(delecoes).catch(() => {});
      }

      // 5. Apaga definitivamente o documento da árvore mestre para fechar o ciclo
      await fDeleteDoc(salaRef);
      alert(`🏆 PARABÉNS CAMPEÃO! O prémio acumulado de ${prémioBolasTotal.toLocaleString()} ⚽ foi transferido com sucesso para a tua conta!`);

    } catch (errResgate) {
      console.error("Erro fatal ao resgatar premiação da Champions:", errResgate);
      alert("Ocorreu um erro ao processar o teu prémio. Tenta novamente!");
    } finally {
      setResgatandoPremio(false);
    }
  };

    const enviarDesafio = async (rival, idBatalhaCustom = null) => {
    // ISOLAMENTO CHAMPIONS: Grava numa coleção 100% separada para não vazar no ArenaPK!
    const idDaMinhaSala = torneioId || salaSelecionadaId;
    if (!idDaMinhaSala || !rival?.uid) return;

    // Se vier um ID customizado da Árvore (Meias ou Final), usa-o; caso contrário, gera o padrão dos Quartos
    const idBatalha = idBatalhaCustom || `champions_jogo_${idDaMinhaSala}_${auth.currentUser.uid}`; 

    const { doc: fDoc, setDoc: fSetDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');

    await fSetDoc(fDoc(db, "champions_partidas", idBatalha), {
      pontosA: 0, pontosB: 0, prontoA: false, prontoB: false, fase: "ESPERA", 
      idA: auth.currentUser.uid, 
      idB: rival.uid, 
      nomeA: meusDados?.nomeCompleto || "Jogador A", 
      nomeB: rival?.nomeCompleto || "Jogador B",
      fotoA: meusDados?.fotoUrl || '',
      fotoB: rival?.fotoUrl || '',
      tipoBatalha: "champions",
      salaTorneioId: idDaMinhaSala
    });

    // Injeta o convite isolado de torneio no rival para ativar o arrastamento automático
    await fUpdateDoc(fDoc(db, "utilizadores", rival.uid), {
      conviteChampions: { de: auth.currentUser.uid, nome: meusDados?.nomeCompleto || "Jogador A", status: 'pendente', idBatalha: idBatalha }
    });

    await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), {
      conviteChampions: { status: 'aguardando', idBatalha: idBatalha }
    });
  };

  const aceitarPK = async () => {
    if (!meusDados?.conviteChampions?.idBatalha || !meusDados?.conviteChampions?.de) return;
    const id = meusDados.conviteChampions.idBatalha;
    
    const { doc: fDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
    await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), { "conviteChampions.status": 'aceite' });
    await fUpdateDoc(fDoc(db, "utilizadores", meusDados.conviteChampions.de), { "conviteChampions.status": 'aceite' });
  };

  const assistirBatalha = (idBatalha) => {
    if (!idBatalha) return;
    setModoEspectador(true);
    setBatalhaAtiva(idBatalha);
  };

    // INSCRIÇÃO COM EFEITO ESTEIRA AUTOMÁTICO (CORRIGIDO COM SINALIZAÇÃO DE SALA)
  const inscreverNoTorneio = async () => {
    // Garante que usamos a sala dinâmica atualizada
    const idDaMinhaSala = salaSelecionadaId || "estadio_global_ativo";

    try {
      const { collection: fCollection, getDocs: fGetDocs, doc: fDoc, setDoc: fSetDoc, updateDoc: fUpdateDoc, serverTimestamp: fServerTimestamp } = await import('firebase/firestore');
      
      const salaInscritosRef = fCollection(db, "champions_salas", idDaMinhaSala, "inscritos");
      const snapInscritos = await fGetDocs(salaInscritosRef);

      const jaInscrito = snapInscritos.docs.some(d => d.id === auth.currentUser?.uid);
      if (jaInscrito) {
        alert("Já estás inscrito na lista de espera deste torneio! ⚽");
        return;
      }

      if (snapInscritos.size >= 8) { 
        alert("Este estádio acabou de encher! Aguarda que o sistema abra o próximo. ⏳"); 
        return; 
      }

      const meuDocInscritoRef = fDoc(db, "champions_salas", idDaMinhaSala, "inscritos", auth.currentUser.uid);
      const dadosMeus = {
        uid: auth.currentUser.uid,
        nome: meusDados?.nomeCompleto || auth.currentUser?.displayName || "Craque",
        foto: meusDados?.fotoUrl || auth.currentUser?.photoURL || '',
        inscritoEm: fServerTimestamp(),
        ativo: true,
        vitorias: 0
      };

      await fSetDoc(meuDocInscritoRef, dadosMeus);
      
      const torneioPublicoRef = fDoc(db, "torneios_abertos", idDaMinhaSala);
      await fSetDoc(torneioPublicoRef, {
        id: idDaMinhaSala,
        status: "aguardando",
        totalVagasPreenchidas: snapInscritos.size + 1,
        criadorNome: "Sistema Oficial"
      }, { merge: true });

      alert("Inscrição confirmada na Champions! Vaga garantida. 🏆");

      // SE É O 8º JOGADOR: DISPARA O TORNEIO E MOVE A ESTEIRA DO MUNDO
      if (snapInscritos.size + 1 === 8) {
        const listaCompleta = snapInscritos.docs.map(d => d.data());
        listaCompleta.push(dadosMeus);

        // 1. Fecha o lobby antigo para novos utilizadores
        await fUpdateDoc(torneioPublicoRef, { status: "em_andamento" });

        // 2. Cria a árvore de jogos fixada nesta sala passando o ID dinâmico correto
        if (typeof gerarChaveamento === 'function') {
          await gerarChaveamento(listaCompleta, idDaMinhaSala);
        }

        // 3. RODA A ESTEIRA: Gera um ID totalmente novo para o próximo torneio
        const novoIdProximaSala = `torneio_champions_${Date.now()}`;
        
        // 4. Atualiza o nó central. Mantém o controlo do torneio ativo e prepara a próxima vaga limpa!
        const controloRef = fDoc(db, "controlo_champions", "torneio_atual");
        await fSetDoc(controloRef, {
          idSalaAtiva: novoIdProximaSala,
          idSalaAnteriorEmAndamento: idDaMinhaSala,
          faseAtualTorneioAnterior: "quartos"
        }, { merge: true });
      }

    } catch (errorInsc) {
      console.error("Erro na validação de inscrição:", errorInsc);
    }
  };

  // FUNÇÃO DE DESISTÊNCIA SEGURA: Liberta a vaga e remove o jogador da lista de espera
  const desistirDaVagaTorneio = async () => {
    // Garante que usamos a sala dinâmica viva onde o utilizador realmente está
    const idDaMinhaSala = salaSelecionadaId || "estadio_global_ativo";
    
    try {
      const { doc: fDoc, deleteDoc: fDeleteDoc, collection: fCollection, getDocs: fGetDocs, updateDoc: fUpdateDoc } = await import('firebase/firestore');
      
      // 1. Remove o documento do jogador da subcoleção de inscritos da sala correta
      await fDeleteDoc(fDoc(db, "champions_salas", idDaMinhaSala, "inscritos", auth.currentUser.uid));
      
      // 2. Atualiza o contador global do Lobby público, decrementando 1 vaga com precisão
      const torneioPublicoRef = fDoc(db, "torneios_abertos", idDaMinhaSala);
      const snapInscritos = await fGetDocs(fCollection(db, "champions_salas", idDaMinhaSala, "inscritos"));
      
      await fUpdateDoc(torneioPublicoRef, {
        totalVagasPreenchidas: snapInscritos.size
      });

      alert("Retiraste a tua inscrição com sucesso. A tua vaga foi libertada! ✕");

    } catch (errorDesist) {
      console.error("Erro ao desistir da vaga:", errorDesist);
    }
  };

    // MOTOR FINANCEIRO: ADESÃO À CLAQUE OFICIAL DA CHAMPIONS (200 BOLAS - 50/50 CHAMPIONS PRESTIGE)
  const determinarClaqueChampions = async (streamerId, streamerNome) => {
    if (!streamerId || streamerId === auth.currentUser?.uid) return;

    try {
      const { doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc, setDoc: fSetDoc, serverTimestamp: fServerTimestamp, increment: fIncrement } = await import('firebase/firestore');
      
      const meuUserRef = fDoc(db, "utilizadores", auth.currentUser.uid);
      const meuSnap = await fGetDoc(meuUserRef);
      const saldoBolasReal = meuSnap.data()?.saldoBolas || meuSnap.data()?.saldo || 0;

      if (saldoBolasReal < 200) {
        alert("Saldo insuficiente para a Claque da Champions! Preço: 200 ⚽");
        return;
      }

      // 1. Deduz as 200 Bolas ao adepto
      const campoSaldoAdepto = meuSnap.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(meuUserRef, { [campoSaldoAdepto]: fIncrement(-200) });

      // 2. Entrega 50% (100 Bolas) ao Streamer apoiado
      const streamerRef = fDoc(db, "utilizadores", streamerId);
      const snapStr = await fGetDoc(streamerRef);
      const campoSaldoStr = snapStr.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(streamerRef, { [campoSaldoStr]: fIncrement(100) });

      // 3. Entrega 50% (100 Bolas) de lucro real à Administração (TRANCADO NO TEU ID REAL!)
      const meuIdAdminTorneioClaque = "wkvSZZR5zdUvweoBuydAept6eOn1";
      await fUpdateDoc(fDoc(db, "utilizadores", meuIdAdminTorneioClaque), {
        comissaoAppBolas: fIncrement(100)
      }).catch(() => {});

      // 4. Grava o sócio vitalício na subcoleção de torneios do Streamer
      const docClaqueRef = fDoc(db, "utilizadores", streamerId, "claque_champions_membros", auth.currentUser.uid);
      await fSetDoc(docClaqueRef, {
        uid: auth.currentUser.uid,
        nome: auth.currentUser?.displayName || "Adepto",
        foto: auth.currentUser?.photoURL || "",
        ativo: true,
        criadoEm: fServerTimestamp()
      });
    
      // 🚨 INJEÇÃO EM TEMPO REAL: Atualiza o contador de ativos na sala de partida da Champions (champions_partidas)
      const idDaMinhaSala = torneioId || salaSelecionadaId;
      if (idDaMinhaSala && jogoAtualNoFirebase && dadosTorneio?.[jogoAtualNoFirebase]) {
        const partidaAtivaId = dadosTorneio[jogoAtualNoFirebase].idBatalha;
        if (partidaAtivaId) {
          const campoAtivo = streamerId === dadosTorneio[jogoAtualNoFirebase].p1?.uid ? "claqueAtivosA" : "claqueAtivosB";
          await fUpdateDoc(fDoc(db, "champions_partidas", partidaAtivaId), {
            [campoAtivo]: fIncrement(1)
          }).catch(() => {});
        }
      }

      alert(`Inscrição carimbada! Agora és membro oficial da Claque de Torneios de ${streamerNome}! 📣🏆`);

    } catch (errClaq) {
      console.error("Erro ao aderir à claque da Champions:", errClaq);
    }
  };

    const gerarChaveamento = async (jogadores, idSalaForcada = null) => {
    const sorteados = [...jogadores].sort(() => Math.random() - 0.5);
    const timestampAtual = Date.now();
    const idDaMinhaSala = idSalaForcada || torneioId || salaSelecionadaId;
    if (!idDaMinhaSala) return;
    
    const jogosIniciais = {
      jogo1: { p1: sorteados[0], p2: sorteados[1], vencedor: null, status: 'pendente', idBatalha: `champions_j1_${timestampAtual}_${idDaMinhaSala}` },
      jogo2: { p1: sorteados[2], p2: sorteados[3], vencedor: null, status: 'pendente', idBatalha: `champions_j2_${timestampAtual}_${idDaMinhaSala}` },
      jogo3: { p1: sorteados[4], p2: sorteados[5], vencedor: null, status: 'pendente', idBatalha: `champions_j3_${timestampAtual}_${idDaMinhaSala}` },
      jogo4: { p1: sorteados[6], p2: sorteados[7], vencedor: null, status: 'pendente', idBatalha: `champions_j4_${timestampAtual}_${idDaMinhaSala}` },
      meia1: { p1: null, p2: null, vencedor: null, status: 'pendente' },
      meia2: { p1: null, p2: null, vencedor: null, status: 'pendente' },
      final: { p1: null, p2: null, vencedor: null, status: 'pendente' },
      faseGeral: 'QUARTOS',
      status: 'em_andamento',
      poteBolasGlobalArvore: 0,
      criadoEm: serverTimestamp()
    };

    const { doc: fDoc, setDoc: fSetDoc } = await import('firebase/firestore');
    await fSetDoc(fDoc(db, "champions_ativa", idDaMinhaSala), jogosIniciais);
  };

  const entrarNoJogoTorneio = async (jogo, nomeDoJogoNoFirebase) => {
    const meuUid = auth.currentUser?.uid;
    if (!jogo || !meuUid) return;

    const isP1 = jogo?.p1?.uid === meuUid;
    const isP2 = jogo?.p2?.uid === meuUid;
    const souJogador = isP1 || isP2;

    if (jogo?.status !== 'pendente') {
      setJogoAtualNoFirebase(nomeDoJogoNoFirebase);
      setModoEspectador(!souJogador);
      setBatalhaAtiva(jogo.idBatalha);
      return;
    }

    if (!souJogador) {
      alert("Este jogo ainda não começou! ⏳");
      return;
    }

        const idDaMinhaSala = torneioId || salaSelecionadaId;
    const { doc: fDoc, updateDoc: fUpdateDoc, setDoc: fSetDoc, serverTimestamp: fServerTimestamp } = await import('firebase/firestore');
    const salaRef = fDoc(db, "champions_ativa", idDaMinhaSala);

      // REVOLUÇÃO SÍNCRONA: Atualiza a prontidão nativa dos concorrentes e arranca a partida!
    await fUpdateDoc(salaRef, { 
      [`${nomeDoJogoNoFirebase}.prontoA`]: true,
      [`${nomeDoJogoNoFirebase}.prontoB`]: true,
      [`${nomeDoJogoNoFirebase}.status`]: "em_andamento"
    });

    // Fallbacks inteligentes para assegurar fotos e nomes nos Quartos, Meias ou Final sem undefined!
    const nomeJogadorA = jogo.p1?.nomeCompleto || jogo.p1?.nome || "Craque A";
    const nomeJogadorB = jogo.p2?.nomeCompleto || jogo.p2?.nome || "Craque B";
    const fotoJogadorA = jogo.p1?.fotoUrl || jogo.p1?.foto || '';
    const fotoJogadorB = jogo.p2?.fotoUrl || jogo.p2?.foto || '';

    // CRIA A PARTIDA IMEDIATAMENTE NA COLEÇÃO CERTA DA CHAMPIONS (NA FASE DE ESPERA)
    await fSetDoc(fDoc(db, "champions_partidas", jogo.idBatalha), {
      pontosA: 0, 
      pontosB: 0, 
      prontoA: false, 
      prontoB: false, 
      fase: "ESPERA", 
      idA: jogo.p1.uid, 
      idB: jogo.p2.uid,
      nomeA: nomeJogadorA, 
      nomeB: nomeJogadorB,
      fotoA: fotoJogadorA, 
      fotoB: fotoJogadorB,
      totalPresentesRecebidosA: 0, 
      totalPresentesRecebidosB: 0,
      tipoBatalha: "champions",
      salaTorneioId: idDaMinhaSala,
      criadoEm: fServerTimestamp()
    });

    // ARRASTAMENTO SIMULTÂNEO: Alinha as fichas dos dois utilizadores logados
    await fUpdateDoc(fDoc(db, "utilizadores", jogo.p1.uid), {
      "conviteChampions.status": "aceite",
      "conviteChampions.idBatalha": jogo.idBatalha
    }).catch(() => {});

    await fUpdateDoc(fDoc(db, "utilizadores", jogo.p2.uid), {
      "conviteChampions.status": "aceite",
      "conviteChampions.idBatalha": jogo.idBatalha
    }).catch(() => {});

    setJogoAtualNoFirebase(nomeDoJogoNoFirebase);
    setModoEspectador(false);
    setBatalhaAtiva(jogo.idBatalha);
  };

  // SÓ ENTRA AUTOMATICAMENTE SE O JOGO REALMENTE ESTIVER ATIVO NA ÁRVORE
  if (batalhaAtiva && dadosTorneio?.faseGeral !== "FIM" && dadosTorneio?.status !== "encerrado") {
    return (
      <TorneiosPK
        idJogoNaArvore={jogoAtualNoFirebase}
        idBatalha={batalhaAtiva} 
        idA={dadosTorneio?.[jogoAtualNoFirebase]?.p1?.uid || "estadio_global_ativo"}
        espectador={modoEspectador} 
        determinarClaqueChampions={determinarClaqueChampions}
        aoSair={() => { setBatalhaAtiva(null); setModoEspectador(false); }}
      />
    );
  }

  return (
    <div style={{ 
      backgroundColor: '#000', 
      height: '100vh', 
      maxHeight: '100vh',
      color: 'white', 
      padding: '15px', 
      textAlign: 'center', 
      paddingBottom: '90px',
      overflowY: 'auto', // 🚨 INJEÇÃO DO SCROLL VERTICAL AUTOMÁTICO PARA TELEMÓVEIS!
      WebkitOverflowScrolling: 'touch' // Garante um scroll nativo e suave no iOS e Android
    }}>

          {/* CABEÇALHO */}
      <div style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#39FF14', fontWeight: '900', margin: '0', fontSize: '24px', letterSpacing: '1px' }}>
          CHAMPIONS PK ⚽
        </h2>
      </div>

      {/* BOX DE CONVITE RECEBIDO ISOLADO DA CHAMPIONS (CORRIGIDO PARA USO DINÂMICO) */}
      {meusDados?.conviteChampions?.status === 'pendente' && (
        <div style={{ background: '#fff', color: '#000', padding: '15px', borderRadius: '15px', margin: '10px 0', boxShadow: '0 0 20px #39FF14' }}>
          <p style={{ fontSize: '14px', margin: '0 0 10px 0' }}><b>{meusDados.conviteChampions.nome}</b> desafiou-te para a Eliminatória!</p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button onClick={aceitarPK} style={{ background: '#39FF14', padding: '10px 20px', borderRadius: '8px', border: 'none', fontWeight: '900', cursor: 'pointer' }}>ACEITAR</button>
            <button 
              onClick={async () => {
                const { doc: fDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
                await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), { conviteChampions: null }).catch(() => {});
              }} 
              style={{ background: '#ff4444', color: 'white', padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}
            >
              RECUSAR
            </button>
          </div>
        </div>
      )}

      {dadosTorneio ? (
        <div style={{ paddingBottom: '100px' }}>
          
          {/* BANNER DO POTE MUNDIAL DA CHAMPIONS - TOTALMENTE ACUMULADO AO VIVO! */}
          <div style={{ 
            background: '#0a0a0a', 
            border: '2px solid #FFD700', borderRadius: '20px', 
            padding: '20px', marginBottom: '30px', textAlign: 'center',
            boxShadow: '0 0 25px rgba(255, 215, 0, 0.15)'
          }}>
            <p style={{ color: '#aaa', fontSize: '10px', margin: 0, fontWeight: 'bold', letterSpacing: '3px' }}>PRÉMIO FINAL ACUMULADO</p>
            <h1 style={{ color: '#FFD700', fontSize: '36px', margin: '8px 0', fontWeight: '900', textShadow: '0 0 15px rgba(255, 215, 0, 0.5)' }}>
              {Math.round(poteBolasGeral || 0).toLocaleString()} ⚽
            </h1>
            <div style={{ display: 'inline-block', background: 'rgba(57, 255, 20, 0.1)', padding: '4px 12px', borderRadius: '20px' }}>
              <span style={{ color: '#39FF14', fontSize: '10px', fontWeight: 'bold' }}>● 25% DE CADA PRESENTE ADICIONADO 📈</span>
            </div>
          </div>

          {/* 🚨 TELA DE CELEBRAÇÃO DO CAMPEÃO: SÓ EXIBE SE O TORNEIO ESTIVER CONCLUÍDO (FASE FIM) */}
          {dadosTorneio?.faseGeral === "FIM" ? (
            <div style={{
              background: 'radial-gradient(circle, #1a1a1a 0%, #000 100%)',
              border: '3px double #FFD700',
              borderRadius: '25px',
              padding: '30px 20px',
              marginBottom: '35px',
              textAlign: 'center',
              boxShadow: '0 0 40px rgba(255, 215, 0, 0.4)',
              animation: 'pulse 2s infinite'
            }}>
              <span style={{ fontSize: '60px', display: 'block', marginBottom: '10px', animation: 'bounce 1s infinite' }}>🏆</span>
              <h2 style={{ color: '#FFD700', fontSize: '26px', fontWeight: '950', margin: '0 0 5px 0', textShadow: '0 0 15px #FFD700', letterSpacing: '1px' }}>
                TORNEIO CONCLUÍDO 🎉
              </h2>
              <p style={{ color: '#fff', fontSize: '13px', margin: '0 0 20px 0', fontWeight: 'bold', letterSpacing: '0.5px' }}>
                GRANDE CAMPEÃO: <span style={{ color: '#39FF14', textTransform: 'uppercase', fontSize: '16px', fontWeight: '950' }}>{dadosTorneio.final?.vencedor === dadosTorneio.final?.p1?.uid ? (dadosTorneio.final?.p1?.nomeCompleto || dadosTorneio.final?.p1?.nome) : (dadosTorneio.final?.p2?.nomeCompleto || dadosTorneio.final?.p2?.nome || "Craque Supremo")}</span> 🏅
              </p>
              
              {/* Animação visual de chuvas de bolas simuladas no CSS inline */}
              <p style={{ color: '#aaa', fontSize: '10px', margin: '10px 0', fontStyle: 'italic' }}>✨ Tira um print do teu ecrã e partilha a vitória nas tuas redes sociais! ✨</p>

              {/* Botão Dinâmico de Saque de Prémio: Só fica dourado e ativo para o Campeão Real! */}
              {dadosTorneio.final?.vencedor === auth.currentUser?.uid ? (
                <button
                  disabled={resgatandoPremio}
                  onClick={resgatarPremioFinalCampeao}
                  style={{
                    marginTop: '15px',
                    background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                    color: 'black',
                    border: 'none',
                    padding: '16px 32px',
                    borderRadius: '15px',
                    fontWeight: '950',
                    fontSize: '15px',
                    boxShadow: '0 0 25px #FFD700',
                    cursor: 'pointer',
                    width: '100%',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    opacity: resgatandoPremio ? 0.6 : 1
                  }}
                >
                  {resgatandoPremio ? "🏆 PROCESSANDO SAQUE..." : `💰 RESGATAR PRÉMIO DE ${Math.round(poteBolasGeral || 0).toLocaleString()} ⚽`}
                </button>
              ) : (
                <div style={{ marginTop: '20px', padding: '10px', background: 'rgba(255,255,255,0.05)', borderRadius: '10px' }}>
                  <p style={{ color: '#666', fontSize: '11px', margin: 0, fontWeight: 'bold' }}>
                    🔒 O prémio está reservado para a carteira do Campeão.
                  </p>
                </div>
              )}
            </div>
          ) : null}

          {/* ESTRUTURA COMPLETA DA ÁRVORE DE JOGOS */}
          <h2 style={{ color: '#FFD700', fontSize: '18px', marginBottom: '20px' }}>QUARTOS-DE-FINAL 🏆</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <CaixaJogo numero="1" jogo={dadosTorneio.jogo1} clicar={() => entrarNoJogoTorneio(dadosTorneio.jogo1, 'jogo1')} />
            <CaixaJogo numero="2" jogo={dadosTorneio.jogo2} clicar={() => entrarNoJogoTorneio(dadosTorneio.jogo2, 'jogo2')} />
            <CaixaJogo numero="3" jogo={dadosTorneio.jogo3} clicar={() => entrarNoJogoTorneio(dadosTorneio.jogo3, 'jogo3')} />
            <CaixaJogo numero="4" jogo={dadosTorneio.jogo4} clicar={() => entrarNoJogoTorneio(dadosTorneio.jogo4, 'jogo4')} />
          </div>

          {/* AVISO DE PERMANÊNCIA DOS JOGADORES - SÓ EXIBE SE O CAMPEONATO ESTIVER EM CURSO */}
          {dadosTorneio?.faseGeral !== "FIM" && (
            <div style={{
              marginTop: '25px',
              backgroundColor: 'rgba(255, 215, 0, 0.05)',
              border: '1px solid rgba(255, 215, 0, 0.2)',
              borderRadius: '12px',
              padding: '12px',
              textAlign: 'center'
            }}>
              <p style={{ color: '#FFD700', margin: 0, fontSize: '13px', fontWeight: 'bold', letterSpacing: '0.5px' }}>
                ⚠️ OS TEUS JOGOS VÃO COMEÇAR, MANTÉM-TE AQUI NESTE ECRÃ!
              </p>
            </div>
          )}

          {/* MEIAS-FINAIS - SÓ RENDERIZA SE O MOTOR DE AVANÇO AUTOMÁTICO INJETAR OS PARTICIPANTES */}
          {dadosTorneio.meia1?.p1 && (
            <div style={{ marginTop: '30px' }}>
              <h2 style={{ color: '#FFD700', fontSize: '18px', marginBottom: '20px' }}>MEIAS-FINAIS 🏆</h2>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <CaixaJogo numero="5" jogo={dadosTorneio.meia1} clicar={() => entrarNoJogoTorneio(dadosTorneio.meia1, 'meia1')} />
                <CaixaJogo numero="6" jogo={dadosTorneio.meia2} clicar={() => entrarNoJogoTorneio(dadosTorneio.meia2, 'meia2')} />
              </div>
            </div>
          )}

          {/* GRANDE FINAL */}
          {dadosTorneio.final?.p1 && (
            <div style={{ marginTop: '40px', padding: '15px', border: '2px dashed #FFD700', borderRadius: '20px', background: 'rgba(255, 215, 0, 0.05)' }}>
              <h2 style={{ color: '#FFD700', fontSize: '22px', marginBottom: '20px', textShadow: '0 0 10px #FFD700', textAlign: 'center' }}>GRANDE FINAL 🏆⭐</h2>
              <div style={{ maxWidth: '200px', margin: '0 auto' }}>
                <CaixaJogo numero="FINAL" jogo={dadosTorneio.final} clicar={() => entrarNoJogoTorneio(dadosTorneio.final, 'final')} />
              </div>
            </div>
          )}
        </div>
      ) : (
        <>

      {/* SECÇÃO DE INSCRIÇÃO CHAMPIONS - SÓ EXIBE SE O TORNEIO REALMENTE NÃO COMEÇOU */}
      {inscritos.length < 8 && (!dadosTorneio || dadosTorneio.status !== "em_andamento") ? (
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ color: '#FFD700', fontSize: '18px', marginBottom: '10px' }}>
            VAGAS PREENCHIDAS: {inscritos.length} / 8
          </h3>
          
          {/* CONTROLO COMPLETO DE VAGAS: Só exibe se a fase do torneio for de inscrições livres */}
          {!inscritos.find(i => i.uid === auth.currentUser?.uid) ? (
            <button 
              onClick={inscreverNoTorneio}
              style={{ 
                background: '#FFD700', color: 'black', border: 'none', 
                padding: '15px 30px', borderRadius: '15px', fontWeight: '900', 
                fontSize: '14px', boxShadow: '0 0 20px rgba(255, 215, 0, 0.4)',
                cursor: 'pointer', width: '100%', textTransform: 'uppercase'
              }}
            >
              INSCREVER NO TORNEIO 🏆
            </button>
          ) : (
            /* Se o utilizador já garantiu a vaga, abre o botão vermelho para desistir da fila */
            <button 
              onClick={desistirDaVagaTorneio}
              style={{ 
                background: '#ff4444', color: 'white', border: 'none', 
                padding: '15px 30px', borderRadius: '15px', fontWeight: '900', 
                fontSize: '14px', boxShadow: '0 0 15px rgba(255, 68, 68, 0.3)',
                cursor: 'pointer', width: '100%', textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              ✕ DESISTIR DA VAGA (SAIR DA FILA)
            </button>
          )}
        </div>
      ) : null}

      {/* LISTA DOS 8 CRAQUES (SÓ PARA VER QUEM JÁ ENTROU NA SALA INFINITA) */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', padding: '10px' }}>
        {inscritos.map(i => {
          const fotoInscrito = i.fotoUrl || i.foto || '/hero.png';
          const nomeInscrito = i.nomeCompleto || i.nome || "Craque";
          
          return (
            <div key={i.uid} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img 
                src={fotoInscrito} 
                onClick={() => determinarClaqueChampions(i.uid, nomeInscrito)}
                style={{ 
                  width: '45px', 
                  height: '45px', 
                  borderRadius: '50%', 
                  border: '2px solid #FFD700', 
                  objectFit: 'cover',
                  cursor: i.uid !== auth.currentUser?.uid ? 'pointer' : 'default',
                  filter: i.uid !== auth.currentUser?.uid ? 'drop-shadow(0 0 4px rgba(255, 215, 0, 0.3))' : 'none'
                }} 
                title={i.uid !== auth.currentUser?.uid ? `Adquirir Claque Oficial de ${nomeInscrito} (200 ⚽)` : "Tu"}
                onError={(e) => { e.target.src = '/hero.png'; }} 
                alt="P" 
              />
              <span style={{ fontSize: '9px', color: '#FFF', marginTop: '5px', fontWeight: 'bold', maxWidth: '70px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {nomeInscrito ? nomeInscrito.split(' ')[0] : "Craque"}
              </span>
            </div>
          );
        })}
      </div>
              </>
      )}

      {/* BARRA DE NAVEGAÇÃO FIXA NO FUNDO (CORRIGIDA COM SEGUIMENTO ASSÍNCRONO) */}
      <div style={{ 
        position: 'fixed', bottom: 0, left: 0, right: 0, height: '75px', 
        backgroundColor: '#111', borderTop: '1px solid #333', 
        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 
      }}>
        <button 
          onClick={async () => {
            const { doc: fDoc, updateDoc: fUpdateDoc, collection: fCollection, query: fQuery, getDocs: fGetDocs, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
            
            // 1. ISOLAMENTO CHAMPIONS: Limpa os campos corretos da rota do torneio ao sair!
            await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), { 
              emChampions: false, conviteChampions: null 
            }).catch(() => {});

            // 2. LIMPEZA TOTAL DO CHAT (Para amanhã estar vazio)
            try {
              const chatRef = fCollection(db, "chatsArena", auth.currentUser.uid, "chat");
              const snapChat = await fGetDocs(fQuery(chatRef));
              const delecoes = snapChat.docs.map(d => fDeleteDoc(d.ref));
              await Promise.all(delecoes);
            } catch (e) { console.log("Chat já limpo"); }

            // 3. Saída segura
            window.history.back();
            setTimeout(() => { if(window.location.pathname.includes('Arena')) window.location.href = '/?app'; }, 500);
          }}
          style={{ background: 'none', border: 'none', color: '#39FF14', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
        >
          <span style={{ fontSize: '26px', marginBottom: '4px' }}>👤</span>
          <span style={{ fontSize: '10px', fontWeight: '900', letterSpacing: '1px' }}>VOLTAR AO PERFIL</span>
        </button>
      </div>
    </div>
  );
}

export default ChampionsPK;

// COMPONENTE PARA DESENHAR CADA JOGO DA TABELA (VERSÃO SUPREMA INTELIGENTE)
const CaixaJogo = ({ jogo, numero, clicar }) => {
  const meuUid = auth?.currentUser?.uid;
  const souP1 = jogo?.p1?.uid === meuUid;
  const souP2 = jogo?.p2?.uid === meuUid;
  const souJogador = souP1 || souP2;

  // Fallbacks premium cruzados para assegurar imagens e nomes reais em qualquer fase da árvore
  const nomeP1 = jogo?.p1?.nomeCompleto || jogo?.p1?.nome || 'Streamer A';
  const nomeP2 = jogo?.p2?.nomeCompleto || jogo?.p2?.nome || 'Streamer B';
  const fotoP1 = jogo?.p1?.fotoUrl || jogo?.p1?.foto || '/hero.png';
  const fotoP2 = jogo?.p2?.fotoUrl || jogo?.p2?.foto || '/hero.png';

  // 🛡️ MOTOR DE ESTADO VISUAL DOS BOTÕES NÉON
  const obterEstadoBotao = (isP1) => {
    const meuPerfilInJogo = isP1 ? jogo?.p1 : jogo?.p2;
    const rivalPerfilInJogo = isP1 ? jogo?.p2 : jogo?.p1;
    const souEu = meuPerfilInJogo?.uid === meuUid;

    // Se o jogo ainda não tem o segundo adversário gerado nas caixas das Meias/Final
    if (!meuPerfilInJogo?.uid) {
      return { texto: "⏳ ESPERA RIVAL", ativo: false, cor: "#555", shadow: "none" };
    }

    // Se o confronto terminou na base de dados
    if (jogo?.status === "encerrado") {
      if (jogo?.vencedor === meuPerfilInJogo?.uid) {
        return { texto: souEu ? "🥇 APURADO!" : "🏆 PASSOU", ativo: false, cor: "#FFD700", shadow: "0 0 10px #FFD700" };
      } else {
        return { texto: souEu ? "❌ ELIMINADO" : "💀 FORA", ativo: false, cor: "#ff4444", shadow: "none" };
      }
    }

    // Se o confronto está em andamento ao vivo no estádio
    if (jogo?.status === "em_andamento") {
      return { texto: "⚔️ EM DIRETO", ativo: true, cor: "#39FF14", shadow: "0 0 12px #39FF14" };
    }

    // Se o jogo está pendente na árvore à espera do apito inicial
    if (souJogador) {
      return { texto: "⚔️ JOGAR PK", ativo: true, cor: "#39FF14", shadow: "0 0 12px #39FF14" };
    } else {
      return { texto: "👁️ ASSISTIR", ativo: true, cor: "#00E5FF", shadow: "0 0 10px #00E5FF" };
    }
  };

  const btnP1 = obterEstadoBotao(true);
  const btnP2 = obterEstadoBotao(false);

  return (
    <div style={{ border: '1px solid #333', padding: '10px', borderRadius: '12px', backgroundColor: '#111', marginBottom: '10px' }}>
      <p style={{ fontSize: '10px', color: '#666', margin: '0 0 8px 0', textAlign: 'center' }}>JOGO {numero}</p>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
        {/* JOGADOR 1 */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <img src={fotoP1} style={{ width: '40px', height: '40px', borderRadius: '50%', border: jogo?.vencedor === jogo?.p1?.uid ? '2px solid #FFD700' : '2px solid #fff', objectFit: 'cover' }} alt="" />
          <p style={{ fontSize: '9px', color: jogo?.vencedor === jogo?.p1?.uid ? '#FFD700' : 'white', margin: '4px 0 0 0', fontWeight: 'bold', maxWidth: '70px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nomeP1}</p>
          
          <button 
            disabled={!btnP1.ativo}
            onClick={clicar} 
            style={{
              marginTop: '6px', padding: '4px 10px', fontSize: '9px', fontWeight: '950', borderRadius: '6px', border: 'none', 
              cursor: btnP1.ativo ? 'pointer' : 'default',
              background: btnP1.cor,
              color: btnP1.cor === '#39FF14' || btnP1.cor === '#FFD700' || btnP1.cor === '#00E5FF' ? 'black' : 'white',
              boxShadow: btnP1.shadow,
              opacity: btnP1.ativo ? 1 : 0.75,
              textTransform: 'uppercase'
            }}
          >
            {btnP1.texto}
          </button>
        </div>

        <div style={{ fontWeight: '900', color: '#FFD700', alignSelf: 'center', margin: '0 10px', fontSize: '12px' }}>VS</div>

        {/* JOGADOR 2 */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
          <img src={fotoP2} style={{ width: '40px', height: '40px', borderRadius: '50%', border: jogo?.vencedor === jogo?.p2?.uid ? '2px solid #FFD700' : '2px solid #fff', objectFit: 'cover' }} alt="" />
          <p style={{ fontSize: '9px', color: jogo?.vencedor === jogo?.p2?.uid ? '#FFD700' : 'white', margin: '4px 0 0 0', fontWeight: 'bold', maxWidth: '70px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nomeP2}</p>
          
          <button 
            disabled={!btnP2.ativo}
            onClick={clicar} 
            style={{
              marginTop: '6px', padding: '4px 10px', fontSize: '9px', fontWeight: '950', borderRadius: '6px', border: 'none', 
              cursor: btnP2.ativo ? 'pointer' : 'default',
              background: btnP2.cor,
              color: btnP2.cor === '#39FF14' || btnP2.cor === '#FFD700' || btnP2.cor === '#00E5FF' ? 'black' : 'white',
              boxShadow: btnP2.shadow,
              opacity: btnP2.ativo ? 1 : 0.75,
              textTransform: 'uppercase'
            }}
          >
            {btnP2.texto}
          </button>
        </div>
      </div>
    </div>
  );
};


